import type { FC } from 'react';

import type { CommunityMember } from '~/interfaces/community';

import { Avatar } from '../../ui/Avatar';
import { MemberBadge } from '../../ui/MemberBadge';

interface MemberResultRowProps {
  member: CommunityMember;
}

export const MemberResultRow: FC<MemberResultRowProps> = ({ member }) => {
  return (
    <div className="flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-black/5 transition-colors">
      <Avatar src={member.avatar_url} alt={member.name} className="size-8" />
      <div className="flex flex-col min-w-0">
        <span className="flex items-center gap-[6px] min-w-0">
          <span className="font-semibold text-sm text-black truncate">{member.name}</span>
          <MemberBadge
            roles={member.roles}
            isBlocked={member.computed?.blocking === true}
            blockedYou={member.computed?.blocked_you === true}
            badges={member.badges}
            limit={1}
          />
        </span>
        {member.headline && <span className="text-xs text-black/50 truncate">{member.headline}</span>}
      </div>
    </div>
  );
};
